import { render, staticRenderFns } from "./PuhuoTables.vue?vue&type=template&id=18b15f04&scoped=true"
import script from "./PuhuoTables.vue?vue&type=script&lang=js"
export * from "./PuhuoTables.vue?vue&type=script&lang=js"
import style0 from "./PuhuoTables.vue?vue&type=style&index=0&id=18b15f04&prod&lang=scss&scoped=true"
import style1 from "./PuhuoTables.vue?vue&type=style&index=1&id=18b15f04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b15f04",
  null
  
)

export default component.exports